import React, { useContext, useEffect, useState } from 'react';
import CallTableViewModel from '../../../ViewModels/CallTableViewModel';
import { APIContext } from '../../../Contexts/APIContext';
import { useSnackbar } from 'notistack';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import VOCFiltersViewModel from './ViewModel/VOCFiltersViewModel';

interface IFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function VOCDialog(props: IFiltersDialogProps) {
    const { get } = useContext(APIContext);
    const [templateOptions, setTemplateOptions] = useState<string[]>([]);
    const [questionOptions, setQuestionOptions] = useState<string[]>([]);
    const [vocFilter, setVocFilter] = useState<VOCFiltersViewModel>(props.callTableViewModel.filters.vocFilters);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (props.open) {
            setVocFilter(props.callTableViewModel.filters.vocFilters);
        }
    }, [props.open])

    useEffect(() => {
        getTemplateOptions();
    }, []);

    useEffect(() => {
        ClearOptions();
        if (vocFilter.channel !== '') getQuestionOptions();
    }, [vocFilter.channel]);

    //#region database calls
    const getTemplateOptions = () => {
        get('AIAnalysis', `GetVOCTemplateOptions?client=` + props.callTableViewModel.filters.client, (data) => {
            setTemplateOptions(data);
        });
    }

    const getQuestionOptions = () => {
        get('AIAnalysis', `GetVOCQuestionOptions?client=` + props.callTableViewModel.filters.client + `&channel=` + vocFilter.channel, (data) => {
            setQuestionOptions(data)
        });
    }
    //#endregion

    const ClearOptions = () => {
        setVocFilter({
            ...vocFilter,
            question: "",
            answer: ""
        });
    }

    const HandleSelect = (key: string, value: string) => {
        setVocFilter({
            ...vocFilter,
            [key]: value
        });
    }
    
    const Confirm = () => {
        if (vocFilter.channel !== '' && vocFilter.question !== '') {
            const newCallTableViewModel = { ...props.callTableViewModel };

            newCallTableViewModel.filters.vocFilters = vocFilter;

            props.setCallTableViewModel({
                ...newCallTableViewModel
            })
            props.setOpen(false);
        } else {
            enqueueSnackbar("All values must be selected to confirm", { variant: 'warning' });
        }
    }

    return (
        <Dialog onClose={() => props.setOpen(false)} open={props.open} fullWidth maxWidth="sm">
            <DialogTitle>Voice Of The Customer</DialogTitle>
            <DialogContent>
                {templateOptions.length > 0 ?
                    <Grid container style={{ width: '100%' }}>
                        <Grid size={12}>
                            <InputLabel>Channel</InputLabel>
                            <TextField
                                select
                                name="channel"
                                value={vocFilter.channel}
                                onChange={(e) => HandleSelect(e.target.name, e.target.value)}
                                fullWidth
                            >
                                {templateOptions.map((template: string) => {
                                    return (<MenuItem key={template} value={template}>{template}</MenuItem>);
                                })}
                            </TextField>
                        </Grid>
                        {vocFilter.channel !== '' &&
                            <Grid size={12}>
                                <InputLabel>Question</InputLabel>
                                <TextField
                                    select
                                    name="question"
                                    value={vocFilter.question}
                                    onChange={(e) => HandleSelect(e.target.name, e.target.value)}
                                    fullWidth
                                    disabled={vocFilter.channel === '' }
                                >
                                    {questionOptions.length > 0 && questionOptions.map((question: string) => {
                                        return (<MenuItem key={question} value={question}>{question}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        }
                        {vocFilter.channel !== '' && vocFilter.question !== '' &&
                            <Grid size={12}>
                                <InputLabel>Answer</InputLabel>
                                <TextField
                                    select
                                    name="answer"
                                    value={vocFilter.answer}
                                    onChange={(e) => HandleSelect(e.target.name, e.target.value)}
                                    fullWidth
                                    disabled={vocFilter.channel === '' && vocFilter.question === ''}
                                >
                                    <MenuItem key={0} value="Yes">Yes</MenuItem>
                                    <MenuItem key={1} value="No">No</MenuItem>
                                    <MenuItem key={2} value="N/A">N/A</MenuItem>
                                </TextField>
                            </Grid>
                        }
                    </Grid>
                    :
                    <p>This AI Filter Is Not Used By This Client</p>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpen(false)} color="primary">Cancel</Button>
                {templateOptions.length > 0 &&
                    <Button onClick={Confirm} color="primary">Confirm</Button>
                }
            </DialogActions>
        </Dialog>
    )
}